import { render, staticRenderFns } from "./archiveList.vue?vue&type=template&id=2668e579&"
import script from "./archiveList.vue?vue&type=script&lang=js&"
export * from "./archiveList.vue?vue&type=script&lang=js&"
import style0 from "./archiveList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports